<template>
  <div class="wrapper">

    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks" :logo="siteLogoUrl" :mini-logo="siteMiniLogoUrl" :powered-by="showPoweredBy">
      <!-- <user-menu></user-menu> -->
    </side-bar>

    <div class="main-panel" id="main-panel">
      <account-type-banner></account-type-banner>
      <available-workspaces-banner></available-workspaces-banner>
      
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">
      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import AccountTypeBanner from './AccountTypeBanner.vue'
  import AvailableWorkspacesBanner from './AvailableWorkspacesBanner.vue'
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'

  import { mapState, mapGetters } from "vuex";

  export default {
    components: {
      AccountTypeBanner,
      AvailableWorkspacesBanner,
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
    },
    data() {
      return {
      }
    },
    computed: {
        ...mapGetters("config", ["siteLogoUrl", "siteMiniLogoUrl", "showPoweredBy"])
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
